"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sso = exports.initialState = void 0;
const monocle = require("monocle-ts");
const fp = require("fp-ts");
const Actions = require("../../actionTypes/sso");
//#endregion
const managementInitialState = {
    list: [],
    listStatus: 'STANDBY',
    listSelected: [],
    removeStatus: 'STANDBY',
    current: null,
    currentStatus: 'STANDBY',
    currentSaveStatus: 'STANDBY',
    createStatus: 'STANDBY',
    clientList: [],
    clientListStatus: 'STANDBY',
    companyList: [],
    companyListStatus: 'STANDBY',
    selectedCompanies: [],
    detachCompanyStatus: 'STANDBY',
    attachCompanyStatus: 'STANDBY',
    companySearch: [],
    companySearchStatus: 'STANDBY',
    listUsers: [],
    listUsersStatus: 'STANDBY',
    convertUsersStatus: 'STANDBY',
    addDomainStatus: 'STANDBY'
};
//#region INITIAL STATE
exports.initialState = {
    list: [],
    status: 'STANDBY',
    verify: fp.option.none,
    verifyStatus: 'STANDBY',
    management: Object.assign({}, managementInitialState)
};
//#endregion
//#region LENS
const listLens = monocle.Lens.fromProp('list');
const statusLens = monocle.Lens.fromProp('status');
const verifyLens = monocle.Lens.fromProp('verify');
const verifyStatusLens = monocle.Lens.fromProp('verifyStatus');
const managementLens = monocle.Lens.fromProp('management');
const managementListLens = monocle.Lens.fromProp('list');
const managementListStatusLens = monocle.Lens.fromProp('listStatus');
const managementListSelectedLens = monocle.Lens.fromProp('listSelected');
const managementRemoveStatusLens = monocle.Lens.fromProp('removeStatus');
const managementCurrentLens = monocle.Lens.fromProp('current');
const managementCurrentStatusLens = monocle.Lens.fromProp('currentStatus');
const managementCurrentSaveStatusLens = monocle.Lens.fromProp('currentSaveStatus');
const managementClientListLens = monocle.Lens.fromProp('clientList');
const managementClientListStatusLens = monocle.Lens.fromProp('clientListStatus');
const managementCompanyListLens = monocle.Lens.fromProp('companyList');
const managementCompanyListStatusLens = monocle.Lens.fromProp('companyListStatus');
const createStatusLens = monocle.Lens.fromProp('createStatus');
const selectedCompaniesLens = monocle.Lens.fromProp('selectedCompanies');
const detachCompanyStatusLens = monocle.Lens.fromProp('detachCompanyStatus');
const attachCompanyStatusLens = monocle.Lens.fromProp('attachCompanyStatus');
const companySearchLens = monocle.Lens.fromProp('companySearch');
const companySearchStatusLens = monocle.Lens.fromProp('companySearchStatus');
const listUsersLens = monocle.Lens.fromProp('listUsers');
const listUsersStatusLens = monocle.Lens.fromProp('listUsersStatus');
const convertUsersStatusLens = monocle.Lens.fromProp('convertUsersStatus');
const addDomainStatusLens = monocle.Lens.fromProp('addDomainStatus');
const methods = {};
// LIST
methods[Actions.FETCH_LIST_REQUEST] = (state) => statusLens.set('FETCHING')(state);
methods[Actions.FETCH_LIST_SUCCESS] = (state, action) => fp.function.compose(listLens.set(action.payload), statusLens.set('FETCHED'))(state);
methods[Actions.FETCH_LIST_FAILURE] = (state) => statusLens.set('FAILURE')(state);
// VERIFY
methods[Actions.VERIFY_REQUEST] = (state) => verifyStatusLens.set('FETCHING')(state);
methods[Actions.VERIFY_SUCCESS] = (state, action) => fp.function.compose(verifyLens.set(fp.option.some(action.payload)), verifyStatusLens.set('FETCHED'))(state);
methods[Actions.VERIFY_FAILURE] = (state) => verifyStatusLens.set('FAILURE')(state);
//#endregion REDUCER
// MANAGEMENT
methods[Actions.FETCH_MANAGEMENT_LIST_REQUEST] = (state) => managementLens.modify(managementListStatusLens.set('FETCHING'))(state);
methods[Actions.FETCH_MANAGEMENT_LIST_SUCCESS] = (state, action) => managementLens.modify(fp.function.compose(managementListLens.set(action.payload), managementListStatusLens.set('FETCHED')))(state);
methods[Actions.FETCH_MANAGEMENT_LIST_FAILURE] = (state) => managementLens.modify(managementListStatusLens.set('FAILURE'))(state);
methods[Actions.MANAGEMENT_REMOVE_REQUEST] = (state) => managementLens.modify(managementRemoveStatusLens.set('FETCHING'))(state);
methods[Actions.MANAGEMENT_REMOVE_SUCCESS] = (state, action) => managementLens.modify(fp.function.compose(managementListSelectedLens.set([]), managementRemoveStatusLens.set('FETCHED')))(state);
methods[Actions.MANAGEMENT_REMOVE_FAILURE] = (state) => managementLens.modify(managementRemoveStatusLens.set('FAILURE'))(state);
methods[Actions.MANAGEMENT_LIST_SELECT] = (state, action) => managementLens.modify(managementListSelectedLens.modify((cur) => {
    const item = cur.find((z) => z.id === action.payload.sso.id);
    if (action.payload.select) {
        if (!item) {
            return [...cur, action.payload.sso];
        }
    }
    else {
        return cur.filter((z) => z.id !== action.payload.sso.id);
    }
    return cur;
}))(state);
methods[Actions.FETCH_MANAGEMENT_CURRENT_REQUEST] = (state) => managementLens.modify(managementCurrentStatusLens.set('FETCHING'))(state);
methods[Actions.FETCH_MANAGEMENT_CURRENT_SUCCESS] = (state, action) => managementLens.modify(fp.function.compose(managementCurrentLens.set(action.payload), managementCurrentStatusLens.set('FETCHED')))(state);
methods[Actions.FETCH_MANAGEMENT_CURRENT_FAILURE] = (state) => managementLens.modify(managementCurrentStatusLens.set('FAILURE'))(state);
methods[Actions.SAVE_MANAGEMENT_CURRENT_REQUEST] = (state) => managementLens.modify(managementCurrentSaveStatusLens.set('FETCHING'))(state);
methods[Actions.SAVE_MANAGEMENT_CURRENT_SUCCESS] = (state) => managementLens.modify(managementCurrentSaveStatusLens.set('FETCHED'))(state);
methods[Actions.SAVE_MANAGEMENT_CURRENT_FAILURE] = (state) => managementLens.modify(managementCurrentSaveStatusLens.set('FAILURE'))(state);
methods[Actions.UPDATE_FIELD_MANAGEMENT_CURRENT] = (state, action) => managementLens.modify(managementCurrentLens.modify((x) => {
    if (!x) {
        return x;
    }
    const clone = Object.assign({}, x);
    clone[action.payload.key] = action.payload.value;
    return clone;
}))(state);
methods[Actions.FETCH_MANAGEMENT_CLIENT_LIST_REQUEST] = (state) => managementLens.modify(managementClientListStatusLens.set('FETCHING'))(state);
methods[Actions.FETCH_MANAGEMENT_CLIENT_LIST_SUCCESS] = (state, action) => managementLens.modify(fp.function.compose(managementClientListLens.set(action.payload), managementClientListStatusLens.set('FETCHED')))(state);
methods[Actions.FETCH_MANAGEMENT_CLIENT_LIST_FAILURE] = (state) => managementLens.modify(managementClientListStatusLens.set('FAILURE'))(state);
methods[Actions.FETCH_MANAGEMENT_COMPANY_LIST_REQUEST] = (state) => managementLens.modify(managementCompanyListStatusLens.set('FETCHING'))(state);
methods[Actions.FETCH_MANAGEMENT_COMPANY_LIST_SUCCESS] = (state, action) => managementLens.modify(fp.function.compose(selectedCompaniesLens.set([]), managementCompanyListLens.set(action.payload), managementCompanyListStatusLens.set('FETCHED')))(state);
methods[Actions.FETCH_MANAGEMENT_COMPANY_LIST_FAILURE] = (state) => managementLens.modify(managementCompanyListStatusLens.set('FAILURE'))(state);
methods[Actions.CREATE_NEW_FEDERATION_REQUEST] = (state) => managementLens.modify(createStatusLens.set('FETCHING'))(state);
methods[Actions.CREATE_NEW_FEDERATION_SUCCESS] = (state) => managementLens.modify(createStatusLens.set('FETCHED'))(state);
methods[Actions.CREATE_NEW_FEDERATION_FAILURE] = (state) => managementLens.modify(createStatusLens.set('FAILURE'))(state);
methods[Actions.DETACH_COMPANY_REQUEST] = (state) => managementLens.modify(detachCompanyStatusLens.set('FETCHING'))(state);
methods[Actions.DETACH_COMPANY_SUCCESS] = (state) => managementLens.modify(detachCompanyStatusLens.set('FETCHED'))(state);
methods[Actions.DETACH_COMPANY_FAILURE] = (state) => managementLens.modify(detachCompanyStatusLens.set('FAILURE'))(state);
methods[Actions.ATTACH_COMPANY_REQUEST] = (state) => managementLens.modify(attachCompanyStatusLens.set('FETCHING'))(state);
methods[Actions.ATTACH_COMPANY_SUCCESS] = (state) => managementLens.modify(attachCompanyStatusLens.set('FETCHED'))(state);
methods[Actions.ATTACH_COMPANY_FAILURE] = (state) => managementLens.modify(attachCompanyStatusLens.set('FAILURE'))(state);
methods[Actions.SEARCH_COMPANIES_REQUEST] = (state) => managementLens.modify(companySearchStatusLens.set('FETCHING'))(state);
methods[Actions.SEARCH_COMPANIES_SUCCESS] = (state, action) => managementLens.modify(fp.function.compose(companySearchStatusLens.set('FETCHED'), companySearchLens.set(action.payload)))(state);
methods[Actions.SEARCH_COMPANIES_FAILURE] = (state) => managementLens.modify(companySearchStatusLens.set('FAILURE'))(state);
methods[Actions.TOGGLE_COMPANY] = (state, action) => managementLens.modify(selectedCompaniesLens.modify((x) => {
    const newList = x.filter((y) => y !== action.payload.customer.id);
    if (action.payload.status) {
        return newList.concat([action.payload.customer.id]);
    }
    return newList;
}))(state);
// Users
methods[Actions.LIST_USERS_REQUEST] = (state) => managementLens.modify(listUsersStatusLens.set('FETCHING'))(state);
methods[Actions.LIST_USERS_SUCCESS] = (state, action) => managementLens.modify(fp.function.compose(listUsersLens.set(action.payload), listUsersStatusLens.set('FETCHED')))(state);
methods[Actions.LIST_USERS_FAILURE] = (state) => managementLens.modify(listUsersStatusLens.set('FAILURE'))(state);
methods[Actions.CONVERT_USERS_REQUEST] = (state) => managementLens.modify(convertUsersStatusLens.set('FETCHING'))(state);
methods[Actions.CONVERT_USERS_SUCCESS] = (state) => managementLens.modify(convertUsersStatusLens.set('FETCHED'))(state);
methods[Actions.CONVERT_USERS_FAILURE] = (state) => managementLens.modify(convertUsersStatusLens.set('FAILURE'))(state);
// Domain
methods[Actions.ADD_DOMAIN_REQUEST] = (state) => managementLens.modify(addDomainStatusLens.set('FETCHING'))(state);
methods[Actions.ADD_DOMAIN_SUCCESS] = (state) => managementLens.modify(addDomainStatusLens.set('FETCHED'))(state);
methods[Actions.ADD_DOMAIN_FAILURE] = (state) => managementLens.modify(addDomainStatusLens.set('FAILURE'))(state);
// Clear
methods[Actions.CLEAR_MANAGEMENT_MODALS] = (state) => managementLens.modify((x) => (Object.assign(Object.assign({}, x), { attachCompanyStatus: 'STANDBY', companySearch: [], companySearchStatus: 'STANDBY', createStatus: 'STANDBY' })))(state);
methods[Actions.CLEAR_MANAGEMENT] = (state) => managementLens.set(Object.assign({}, managementInitialState))(state);
const sso = (state = exports.initialState, action) => {
    const fn = methods[action.type];
    if (fn) {
        return fn(state, action);
    }
    return state;
};
exports.sso = sso;
//#endregion
//# sourceMappingURL=index.js.map